import { render } from "./Completion.vue?vue&type=template&id=4a2652d7"
import script from "./Completion.vue?vue&type=script&lang=js"
export * from "./Completion.vue?vue&type=script&lang=js"

import "./Completion.vue?vue&type=style&index=0&id=4a2652d7&lang=css"

import exportComponent from "/home/time/IdeaProjects/mektep-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__